export { default as IndividualForm } from "./individualForm";
export { default as CompanyForm } from "./companyForm";
export { default as CustomerForm } from "./customerForm";
